module.exports = __webpack_public_path__ + "static/media/Img_info_EE8D85.ea8cbe93.jpg";